<template>
  <v-container>
    <ReviewDelete v-if="this.$route.params.form_name === 'deleteRequest'" />
    <ReviewInvestigator
      v-else-if="
        this.$route.params.object_type === 'investigator' &&
          this.$route.params.form_name === 'personalForm'
      "
    />
    <ReviewVacation
      v-else-if="
        this.$route.params.object_type === 'investigator' &&
          this.$route.params.form_name === 'vacationForm'
      "
    />
    <ReviewNewVinculation
      v-else-if="
        this.$route.params.object_type === 'investigator' &&
          this.$route.params.form_name === 'vinculationForm'
      "
    />
    <ReviewModifyVinculation
      v-else-if="
        this.$route.params.object_type === 'investigator' &&
          this.$route.params.form_name === 'modifyVinculationForm'
      "
    />
    <ReviewExternalPeople
      v-else-if="
        this.$route.params.object_type === 'investigator' &&
          this.$route.params.form_name === 'externalPeopleForm'
      "
    />
    <ReviewNewInvestigator
      v-else-if="
        this.$route.params.object_type === 'investigator' &&
          this.$route.params.form_name === 'newInvestigatorForm'
      "
    />
    <ReviewModifyExpirationDate
      v-else-if="
        this.$route.params.object_type === 'investigator' &&
          this.$route.params.form_name === 'modifyExpirationDateForm'
      "
    />
    <ReviewModifyResponsible
      v-else-if="
        this.$route.params.object_type === 'investigator' &&
          this.$route.params.form_name === 'modifyResponsibleForm'
      "
    />
    <ReviewModifyServices
      v-else-if="
        this.$route.params.object_type === 'investigator' &&
          this.$route.params.form_name === 'modifyServicesForm'
      "
    />
    <ReviewWorkplaceForm
      v-else-if="
        this.$route.params.object_type === 'investigator' &&
          this.$route.params.form_name === 'modifyWorkplaceForm'
      "
    />
    <ReviewExtendWorkplaceAssignation
      v-else-if="
        this.$route.params.object_type === 'investigator' &&
          this.$route.params.form_name === 'workplaceAssignationForm'
      "
    />
    <ReviewAffiliationForm v-else-if="this.$route.params.object_type === 'investigator' &&
    this.$route.params.form_name === 'affiliationForm'"/>
    <ReviewNewArticle
      v-else-if="
        this.$route.params.object_type === 'publication' &&
          this.$route.params.form_name === 'newArticleForm'
      "
    />
    <ReviewModifyBasicData v-else-if="this.$route.params.object_type === 'publication' &&
    this.$route.params.form_name === 'modifyBasicDataForm'"/>

    <ReviewNewBookAndChapter  v-else-if="this.$route.params.object_type === 'publication' &&
    this.$route.params.form_name === 'newBookAndChapterForm'"/>
    <ReviewCommunication  v-else-if="this.$route.params.object_type === 'publication' &&
    this.$route.params.form_name === 'newCommunicationForm'"/>
    <ReviewThesis v-else-if="this.$route.params.object_type === 'publication' &&
    this.$route.params.form_name === 'newThesisForm'"/>
    <ReviewProjectForms v-else-if="this.$route.params.object_type === 'project' &&
    (this.$route.params.form_name === 'newProjectForm' || this.$route.params.form_name === 'modifyProjectForm')"/>
    <ReviewPressForms  v-else-if="this.$route.params.object_type === 'news' &&
    (this.$route.params.form_name === 'newPressNewForm' || this.$route.params.form_name === 'modifyPressNewForm')"/>
    <ReviewStayForms  v-else-if="this.$route.params.object_type === 'stay' &&
    (this.$route.params.form_name === 'newStayForm' || this.$route.params.form_name === 'modifyStayForm')"/>
    <ReviewSoftwareForms v-else-if="this.$route.params.object_type === 'software' &&
    (this.$route.params.form_name === 'newSoftwareForm' || this.$route.params.form_name === 'modifySoftwareForm')"/>
    <ReviewDatasetForms v-else-if="this.$route.params.object_type === 'dataset'" />
    <ReviewIndustrialPropertyForms
      v-else-if="this.$route.params.object_type === 'industrial_property'"
    />
  </v-container>
</template>

<script>
import ReviewInvestigator from "../components/investigators/reviews/ReviewInvestigator";
import ReviewNewArticle from "../components/publications/reviews/ReviewNewArticle";
import ReviewDelete from "../components/delete_object/ReviewDelete";
import ReviewVacation from "../components/investigators/reviews/ReviewVacation";
import ReviewExternalPeople from "../components/investigators/reviews/ReviewExternalPeople";
import ReviewNewInvestigator from "../components/investigators/reviews/ReviewNewInvestigator";
import ReviewNewVinculation from "../components/investigators/reviews/ReviewNewVinculation";
import ReviewModifyVinculation from "../components/investigators/reviews/ReviewModifyVinculation";
import ReviewModifyExpirationDate from "../components/investigators/reviews/ReviewModifyExpirationDate";
import ReviewModifyResponsible from "../components/investigators/reviews/ReviewModifyResponsible";
import ReviewModifyServices from "../components/investigators/reviews/ReviewModifyServices";
import ReviewWorkplaceForm from "../components/investigators/reviews/ReviewWorkplaceForm";
import ReviewExtendWorkplaceAssignation from "../components/investigators/reviews/ReviewExtendWorkplaceAssignation";
import ReviewModifyBasicData from "../components/publications/reviews/ReviewModifyBasicData";
import ReviewNewBookAndChapter from "../components/publications/reviews/ReviewNewBookAndChapter";
import ReviewCommunication from "../components/publications/reviews/ReviewCommunication";
import ReviewThesis from "../components/publications/reviews/ReviewThesis";
import ReviewAffiliationForm from "../components/investigators/reviews/ReviewAffiliationForm";
import ReviewProjectForms from "../components/projects/reviews/ReviewProjectForms";
import ReviewPressForms from "@/components/newsPress/reviews/ReviewPressForms";
import ReviewStayForms from "@/components/stays/reviews/ReviewStayForms";
import ReviewSoftwareForms from "@/components/software/reviews/ReviewSoftwareForms.vue";
import ReviewDatasetForms from "@/components/datasets/reviews/ReviewDatasetForms.vue";
import ReviewIndustrialPropertyForms from "@/components/industrialProperty/reviews/ReviewIndustrialPropertyForms.vue";
export default {
  name: "Reviews",
  components: {
    ReviewIndustrialPropertyForms,
    ReviewDatasetForms,
    ReviewSoftwareForms,
    ReviewStayForms,
    ReviewPressForms,
    ReviewProjectForms,
    ReviewAffiliationForm,
    ReviewThesis,
    ReviewCommunication,
    ReviewNewBookAndChapter,
    ReviewWorkplaceForm,
    ReviewModifyServices,
    ReviewModifyResponsible,
    ReviewModifyExpirationDate,
    ReviewModifyVinculation,
    ReviewNewVinculation,
    ReviewNewInvestigator,
    ReviewExternalPeople,
    ReviewVacation,
    ReviewDelete,
    ReviewNewArticle,
    ReviewInvestigator,
    ReviewExtendWorkplaceAssignation,
    ReviewModifyBasicData
  },
  created() {
    let item = {
      text: "section." + this.$route.params.form_name,
      disabled: true,
      last: true
    };
    if (
      !this.$route.meta.breadCrumb.some(breadcrumb => {
        return breadcrumb.last === true;
      })
    ) {
      this.$route.meta.breadCrumb.push(item);
    } else {
      this.$route.meta.breadCrumb.pop();
      this.$route.meta.breadCrumb.push(item);
    }
    this.$store.state.sectionTitle = "section." + this.$route.params.form_name;
  }
};
</script>
